export enum CustomizationTypeEnum {
  OPTION = "OPTION",
  VARIANT = "VARIANT"
}
